import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import {
  MatTreeModule,
  MatButtonModule,
  MatIconModule,
  MatInputModule,
  MatFormFieldModule,
  MatSelectModule,
  MatAutocompleteModule
} from '@angular/material';

import { SharedModule } from '../shared/shared.module';
import { TreeParser } from './tree-parser.service';
import { TreeComponent } from './tree/tree.component';
import { AgGridModule } from '@ag-grid-community/angular';
import { ReactiveFormsModule } from '@angular/forms';
import { DevelopmentModule } from '../development/development.module';



@NgModule({
  declarations: [TreeComponent],
  imports: [
    CommonModule,
    MatTreeModule,
    MatButtonModule,
    MatIconModule,
    MatInputModule,
    MatFormFieldModule,
    SharedModule,
    AgGridModule,
    ReactiveFormsModule,
    MatSelectModule,
    MatAutocompleteModule,
    DevelopmentModule,
  ],

  providers: [TreeParser],

  exports: [ MatTreeModule, MatButtonModule, MatIconModule, TreeComponent],
})

export class TreeModule { }
